import type { InGameCommStyle } from 'generated/openapi';
import { type HTMLAttributes, memo } from 'react';

import { IN_GAME_COMM_STYLE_MAP } from '@/features/profile/utils/inGameCommStyle';
import { Badge } from '@/shared/components/ui/badge';
import { Card } from '@/shared/components/ui/card';

export interface ProfileDetailsVibeCommsVibeProps extends HTMLAttributes<HTMLDivElement> {
  commStyle?: InGameCommStyle | InGameCommStyle[];
}

export const ProfileDetailsVibeCommsVibe = memo(
  function ProfileDetailsVibeCommsVibe({
    commStyle,
    ...props
  }: ProfileDetailsVibeCommsVibeProps) {
    if (!commStyle) return null;

    const styles = Array.isArray(commStyle) ? commStyle : [commStyle];
    if (styles.length === 0) return null;

    return (
      <Card variant="data" {...props}>
        <p className="text-sm leading-5 font-bold">Comms vibe</p>
        <div className="flex flex-wrap gap-2">
          {styles.map(style => {
            const option = IN_GAME_COMM_STYLE_MAP.get(style);
            if (!option) return null;
            return (
              <Badge key={style} variant="display">
                {option.label}
              </Badge>
            );
          })}
        </div>
      </Card>
    );
  },
);
